import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';
import AdminLayout from '../components/AdminLayout';

const AdminReports = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground mb-2">Reports Management</h1>
          <p className="text-muted-foreground">Handle user-submitted reports</p>
        </div>

        <Card>
          <CardContent className="p-12 text-center">
            <AlertTriangle className="w-16 h-16 mx-auto mb-4 text-yellow-600" />
            <h3 className="text-xl font-semibold mb-2">Reports System</h3>
            <p className="text-muted-foreground">No reports submitted yet. This page will show user-submitted reports when available.</p>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};

export default AdminReports;